// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5ca76cc3","24":"53a86609","119":"d9b171b1","186":"8b6fbb26","225":"2d10b374","315":"cf2db50e","344":"2fcb5523","372":"8a171988","373":"ec4c2da1","377":"4ff858c8","453":"65df469b","527":"e90916c8","681":"d1067c96","738":"ea4a438b","841":"781c52ef","856":"c66d933a"}[chunkId] + ".chunk.js";
};